import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Shield, Clock } from 'lucide-react';
export function ValueStack() {
  const items = ['Protocolo Calma 3 Minutos — PDF completo', 'Guía de bolsillo imprimible', 'Checklists de aplicación por capítulo', 'Scripts y frases exactas listos para usar', 'Worksheets de escenarios de alto riesgo', 'FAQ de intervención rápida'];
  return <section id="pricing" className="py-24 px-6 bg-brand-charcoal text-white relative overflow-hidden" data-id="element-400">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-orange/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-401"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-402">
        <FadeIn data-id="element-403">
          <div className="bg-white text-brand-charcoal rounded-3xl overflow-hidden shadow-2xl" data-id="element-404">
            <div className="p-8 md:p-12" data-id="element-405">
              <h2 className="text-3xl font-bold text-center mb-10" data-id="element-406">
                Todo lo que recibes hoy
              </h2>

              <div className="space-y-3 mb-8" data-id="element-407">
                {items.map((item, index) => <div key={index} className="flex items-center p-4 bg-gray-50 rounded-xl" data-id="element-408">
                    <div className="flex items-center gap-3" data-id="element-409">
                      <span className="w-2 h-2 rounded-full bg-brand-sage flex-shrink-0" data-id="element-410"></span>
                      <span className="text-gray-800 font-medium" data-id="element-411">{item}</span>
                    </div>
                  </div>)}
              </div>

              <div className="border-t-2 border-gray-200 pt-6 mb-8" data-id="element-412">
                <div className="flex items-center justify-between mb-6" data-id="element-413">
                  <span className="text-xl text-gray-600 font-medium" data-id="element-414">
                    Valor total real:
                  </span>
                  <span className="text-2xl text-gray-400 line-through font-bold decoration-red-500 decoration-2" data-id="element-415">
                    $15.99
                  </span>
                </div>
                <div className="bg-brand-cream p-6 rounded-2xl text-center" data-id="element-416">
                  <p className="text-brand-orange font-bold mb-2 uppercase tracking-wider text-sm" data-id="element-417">
                    🔥 Tu inversión hoy
                  </p>
                  <p className="text-6xl font-black text-gray-900" data-id="element-418">$9.99</p>
                </div>
              </div>

              <div className="text-center" data-id="element-419">
                <Button fullWidth className="mb-4" href="https://www.tumundoequilibrado.com/cart/51386600358183:1" data-id="element-420">
                  👉 SÍ QUIERO EL PROTOCOLO AHORA
                </Button>
                <p className="text-sm text-gray-500 font-medium" data-id="element-421">
                  Descarga instantánea • PDF listo para leer hoy
                </p>
              </div>
            </div>

            <div className="bg-brand-orange text-white p-4 flex items-center justify-center gap-3" data-id="element-422">
              <Clock className="w-5 h-5 animate-pulse" data-id="element-423" />
              <p className="font-medium text-sm md:text-base" data-id="element-424">
                Precio de lanzamiento ($9.99). Cuando termine esta fase, el
                precio sube a $15.99.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Guarantee - Seal Style */}
        <FadeIn delay={0.2} data-id="element-425">
          <div className="mt-12 bg-brand-sage-light text-brand-charcoal rounded-3xl p-8 md:p-10 text-center border-4 border-brand-sage" data-id="element-426">
            <Shield className="w-16 h-16 text-brand-sage mx-auto mb-6" data-id="element-427" />
            <h3 className="text-3xl font-black mb-2 uppercase tracking-wide" data-id="element-428">
              🛡️ GARANTÍA 7 DÍAS
            </h3>
            <p className="text-xl font-bold text-brand-sage mb-6 uppercase" data-id="element-429">
              DEVOLUCIÓN TOTAL SIN PREGUNTAS
            </p>

            <div className="max-w-2xl mx-auto space-y-3 text-lg mb-6" data-id="element-430">
              <p data-id="element-431">Lee el protocolo completo.</p>
              <p data-id="element-432">Aplícalo en una crisis real.</p>
              <p className="font-medium" data-id="element-433">
                Si no te dio absolutamente nada de valor, escríbenos y te
                devolvemos cada centavo.
              </p>
            </div>

            <div className="space-y-2 text-gray-700 mb-6" data-id="element-434">
              <p data-id="element-435">Sin formularios.</p>
              <p data-id="element-436">Sin explicaciones.</p>
              <p data-id="element-437">Sin demoras.</p>
            </div>

            <div className="h-px bg-brand-sage my-6" data-id="element-438"></div>

            <p className="text-2xl font-bold text-brand-charcoal" data-id="element-439">
              Riesgo cero. Decisión simple.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}